/* TODO:: @artfuldev enable the lint and fix the button.
   Couldn't manually verify the style due to unavailability of notifications data.  */
// eslint-disable-next-line no-restricted-imports
import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { Button } from 'components/atoms/button';
import { Tag } from 'components/atoms/tag';
import { BodyShort01 } from 'components/styles';
import { TranslationKey, useTranslation } from 'hooks/use-translation';

const BasicStyles = css`
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  margin: 0;
  gap: var(--spacing-02);
`;

export const Value = styled.div`
  ${BasicStyles};
`;

export const Strong = styled(Value)`
  font-weight: var(--font-weight-bold);
`;

const InlineButton = styled(Button)`
  --hover-color: transparent;
  ${BasicStyles};
  padding: 0;
  height: auto;
  border: none;
  margin-right: var(--spacing-02);
  height: var(--line-height-body-short-01);

  span {
    ${BodyShort01};
    max-width: 250px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const InlineLink: FC<{ title: string; open?: () => void }> = ({
  title,
  open,
}) => (
  <InlineButton title={title} type="link" size="small" onClick={open}>
    {title}
  </InlineButton>
);

export const ReadableTag = styled(Tag)`
  ${BodyShort01};
`;

export const useNotificationMessage = (key: string) =>
  useTranslation(`notifications.messages.${key}` as TranslationKey);
